// extracted by mini-css-extract-plugin
export default {"Produtos_Container":"produtos_Produtos_Container__g1Dcg"};